const cities = [
    'Ağcabədi',
    'Ağdam',
    'Ağdaş',
    'Ağdərə',
    'Ağstafa',
    'Ağsu',
    'Astara',
    'Bakı',
    'Balakən',
    'Beyləqan',
    'Bərdə',
    'Biləsuvar',
    'Cəbrayıl',
    'Cəlilabad',
    'Culfa',
    'Daşkəsən',
    'Füzuli',
    'Gədəbəy',
    'Gəncə',
    'Goranboy',
    'Göyçay',
    'Göygöl',
    'Göytəpə',
    'Hacıqabul',
    'Horadiz',
    'İmişli',
    'İsmayıllı',
    'Kəlbəcər',
    'Kürdəmir',
    'Laçın',
    'Lerik',
    'Lənkəran',
    'Masallı',
    'Mingəçevir',
    'Nabran',
    'Naftalan',
    'Naxçıvan',
    'Neftçala',
    'Oğuz',
    'Ordubad',
    'Qax',
    'Qazax',
    'Qəbələ',
    'Qobustan',
    'Quba',
    'Qubadlı',
    'Qusar',
    'Saatlı',
    'Sabirabad',
    'Şabran',
    'Şahbuz',
    'Salyan',
    'Şamaxı',
    'Samux',
    'Şəki',
    'Şəmkir',
    'Şərur',
    'Şirvan',
    'Siyəzən',
    'Sumqayıt',
    'Şuşa',
    'Tərtər',
    'Tovuz',
    'Ucar',
    'Xaçmaz',
    'Xankəndi',
    'Xırdalan',
    'Xızı',
    'Xocalı',
    'Xocavənd',
    'Xudat',
    'Yardımlı',
    'Yevlax',
    'Zaqatala',
    'Zəngilan',
    'Zərdab',
];

export default cities;